export default "/images/8699c41ab2f353a17c81de45ebdc4331.avif";